
import BuySellYourHomeInfo from '@/components/page-specific/home/featured-in-section/info';
import BuySellYourHomeSection from '../section';
import IconBox from './icon-box';
import { StylePositionType, StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { ExternalLinks } from '@/utils/external-navigation/constants';
import ExternalLink from '@/ui-kit/components/external-link';
import routes from '@/constants/routes';
import Icon from '@/ui-kit/components/icon';
import Button from '@/ui-kit/components/button';
import { IconType } from '@/ui-kit/components/icon/enums';
import Gutter from '@/ui-kit/components/gutter';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';

export default {
  name: 'StatSection',
  components: {
    Typography,
    Icon,
    Button,
    ExternalLink,
    BuySellYourHomeInfo,
    Gutter,
    IconBox,
    BuySellYourHomeSection,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    storeName: {
      type: String,
      required: true,
    },
    trackEvent: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      routes,
      IconType,
      ExternalLinks,
      StylePositionType,
      StyleSizeType,
      StyleColorSchemeType,
      TypographyType,
    };
  },
  computed: {
    statContent() {
      return this.$store.state[this.storeName].statContent;
    },
    informationContent() {
      return this.$store.state[this.storeName].informationContent;
    },
  },
  methods: {
    handleGetStartedClick() {
      const { userId, email } = this.user;

      this.$track('Sell your home_Everything you need_button click', {
        userId,
        email,
      });
    },
  },
};
